var React = require('react');
var ReactNative = require('react-native');
var Globals = require('./Globals');
var ModelConstants = require('./constants/ModelConstants');
var createReactClass = require('create-react-class');
var {
  View,
  StyleSheet,
  Platform,
  Image,
  TouchableOpacity
} = ReactNative;

var MK = require('./wrappers/react-native-material-kit-wrapper');

var {
  MKSpinner
} = MK;

var ReUpButton = require('./ReUpButton');

var AddToWalletButton = createReactClass(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      initialLayout : {},
    }
  },

  getInitialState : function()
  {
    return {
      iframeSrc:"",
      showSpinner:false,
    }
  },

  componentDidMount : function()
  {
  },

  componentWillUnmount : function()
  {
  },

  _downloadCounter : 0, // used to force the iframe reload
  downloadPass : function()
  {
    if( this.state.showSpinner ) return;

    var thisThing = this;
    var appManager = this.props.appManager;
    var appID = appManager._appData["Header"].AppID;
    var userID = appManager.currentUser()[ModelConstants.UserID];
    var hash = appManager.currentUser()[ModelConstants.Hash];
    var hostname = window.location.hostname;
    var baseURL = "https://api.getreup.com/misc/generate_pass.php";
    if( typeof hostname !== 'undefined' )
    {
      if( hostname.indexOf(".dev.") >= 0 )
      {
        baseURL = "https://api.dev.getreup.com/misc/generate_pass.php";
      }
      else if( hostname.indexOf(".stage.") >= 0 )
      {
        baseURL = "https://api.stage.getreup.com/misc/generate_pass.php";
      }
      else if( hostname.indexOf(".feature01.") >= 0 )
      {
        baseURL = "https://api.feature01.getreup.com/misc/generate_pass.php";
      }
      else if( hostname.indexOf(".feature02.") >= 0 )
      {
        baseURL = "https://api.feature02.getreup.com/misc/generate_pass.php";
      }
    }
    var downloadURL = baseURL+"?appid="+appID+"&userid="+userID+"&hash="+hash+"&n="+this._downloadCounter;
    this.setState({showSpinner:true, iframeSrc:downloadURL});
    this._downloadCounter++;

    setTimeout(()=>
    {
      thisThing.setState({showSpinner:false});
    }, 10000);
  },

  shouldRender: function()
  {
    var ua = navigator.userAgent.toLowerCase();
    var isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
    
    return !isAndroid;
  },

  render: function()
  {
    if( !this.shouldRender() ) return null;
    
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();

    return (
      <TouchableOpacity style={[this.props.style, {flexDirection:'column', cursor:'pointer', backgroundColor:'transparent', justifyContent:'center', alignItems:'center'}]}
        onPress={()=> this.downloadPass()}>
        {
          this.state.showSpinner ? 
            <MKSpinner strokeColor={[appManager.getColorForKey("HeaderTitleColor"), appManager.getColorForKey("HeaderColor")]} style={{alignSelf:'center'}}/>
          :
            <Image key={"addtowallet"} resizeMode={"contain"} source={{uri: "https://developer.apple.com/wallet/images/add-to-apple-wallet.svg"}} style={{flex:1, alignSelf:'stretch'}}/>  
        }
        {Platform.OS === 'web' ? <iframe key="iframe" src={this.state.iframeSrc} style={{display:'none'}}></iframe> : null}
      </TouchableOpacity>
    );
  }
});

module.exports = AddToWalletButton;
